export default __webpack_public_path__ + "static/artifakt-legend-bold-e98f65af283bf3069b2acd564dc8812e.eot";